const SearchArrowSVG = ({ className, onClick }) => {
  return (
    <svg
      className={["SearchArrowSVG", className ? className : undefined].join(
        " "
      )}
      onClick={onClick ? onClick : undefined}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 0C7.17647 0 0 7.17647 0 16C0 24.8235 7.17647 32 16 32C24.8235 32 32 24.8235 32 16C32 7.17647 24.8235 0 16 0Z"
        fill="#E3E8FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2746 10.6863C18.1505 10.5621 17.9805 10.4967 17.8171 10.4967C17.6537 10.4967 17.4838 10.5621 17.3596 10.6863L12.5034 15.5425C12.3792 15.6666 12.3139 15.83 12.3139 16C12.3139 16.1699 12.3792 16.3333 12.5034 16.4575L17.3596 21.3137C17.6145 21.5686 18.0197 21.5686 18.2746 21.3137C18.5295 21.0588 18.5295 20.6536 18.2746 20.3987L13.876 16L18.2746 11.6013C18.523 11.3464 18.523 10.9346 18.2746 10.6863Z"
        fill="#3358DA"
      />
    </svg>
  );
};

export default SearchArrowSVG;
